import { render } from "./ApplicationsEdit.vue?vue&type=template&id=5b781338"
import script from "./ApplicationsEdit.vue?vue&type=script&lang=js"
export * from "./ApplicationsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__